"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_LOADING = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeContants = require("../../../constants/themeContants");

var _ThemeComponent = _interopRequireDefault(require("../../Theme/ThemeComponent"));

var _theming = require("../../../theming");

var _useTimer = _interopRequireDefault(require("../../../hooks/useTimer"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DefaultLoading = function DefaultLoading(_ref) {
  var className = _ref.className,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["className", "variant"]);

  return _react["default"].createElement(SignalSpinner, _extends({
    className: className,
    variant: variant
  }, rest));
};

var COMPONENT_LOADING = "COMPONENT_LOADING";
exports.COMPONENT_LOADING = COMPONENT_LOADING;
var themeProps = {
  component: {
    name: "COMPONENT_LOADING",
    description: "Component for loading",
    type: _themeContants.themePropTypes.component
  },
  loading: {
    name: "LOADING",
    description: "Loading style",
    type: _themeContants.themePropTypes.style
  }
};

var Loading = function Loading(_ref2) {
  var className = _ref2.className,
      idleTime = _ref2.idleTime,
      rest = _objectWithoutProperties(_ref2, ["className", "idleTime"]);

  var isReady = (0, _useTimer["default"])(idleTime); // Wait before rendering

  if (!isReady) {
    return null;
  }

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: themeProps.component.name,
    fallback: DefaultLoading
  }, rest));
};

var spinnerBubble1 = (0, _styledComponents.keyframes)(["0%{color:", ";transform:translate(-50%,-50%) scale(1);opacity:1;}100%{color:", ";transform:translate(-50%,-50%) scale(4.8);opacity:0;}"], _theming.color.primary, _theming.color.secondary);
var spinnerBubble2 = (0, _styledComponents.keyframes)(["0%{color:", ";transform:translate(-50%,-50%) scale(1);opacity:1;}100%{color:", ";transform:translate(-50%,-50%) scale(4.8);opacity:0;}"], _theming.color.secondary, _theming.color.primary);

var SignalSpinner = _styledComponents["default"].div.withConfig({
  displayName: "Loading__SignalSpinner",
  componentId: "jmvrwf-0"
})(["position:relative;display:block;width:", ";height:", ";color:", ";&::before,&::after{content:\"\";position:absolute;top:50%;left:50%;width:10px;height:10px;opacity:0;box-shadow:0 0 0 1px;border-radius:50%;transform:translate(-50%,-50%) scale(1);transform-origin:center;}&::before{animation:", " 2.6s ease-out 1.3s infinite;}&::after{animation:", " 2.6s ease-out 0s infinite;}", ";"], _theming.spacing.large, _theming.spacing.large, _theming.color.primary, spinnerBubble1, spinnerBubble2, (0, _theming.applyVariants)(themeProps.loading.name));

Loading.propTypes = {
  className: _propTypes["default"].string,
  variant: _propTypes["default"].string
};
Loading.themeProps = themeProps;
var _default = Loading;
exports["default"] = _default;